/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIceCorpactionsV1ActionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ICE_CORPACTIONS_V1_ACTION_EVENT_ENTITY_NAME = 'exc.ice.corpactions.v1.ActionEvent';
export const excIceCorpactionsV1ActionEventEntity = new schema.Entity<ExcIceCorpactionsV1ActionEvent>(EXC_ICE_CORPACTIONS_V1_ACTION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcIceCorpactionsV1ActionEvent) => `${entity.metadata?.eventId}` });

